import React from "react";
import {ContextMenuManager, ContextMenuType} from "./ContextMenuManager";


import {ItemContextMenu} from "./ItemContextMenu/ItemContextMenu";
import {WorkspaceContextMenu} from "./WorkspaceContextMenu/WorkspaceContextMenu";
import {AddToClusterContextMenu} from "./AddToClusterContextMenu/AddToClusterContextMenu";
import {DocumentContextMenu} from "./DocumentContextMenu/DocumentContextMenu";
import {SelectOptions} from '../../components/form/Select/SelectOptions';
import {CalendarSelectOptions} from "../../components/form/CalendarSelect/CalendarSelectOptions";
import {CalendarSelectRepeatOptions} from "../../components/form/CalendarSelect/CalendarSelectRepeatOptions";
import {TextToolbar} from "./editor/TextToolbar";
import {TriggerToolbar} from "./editor/TriggerToolbar";
import {TableToolbar} from "./editor/TableToolbar";
import {ImageToolbar} from "./editor/ImageToolbar";
import {EmbedToolbar} from "./editor/EmbedToolbar";
import {CalloutToolbar} from "./editor/CalloutToolbar";
import {LinkInContextEditBar} from "./editor/LinkInContextEditBar";
import {PlusToolbar} from "./editor/PlusToolbar";
import {AvatarUploadContextMenu} from "./AvatarUploadContextMenu/AvatarUploadContextMenu";
import {NotificationPanel} from "./NotificationPanel";
import {AcknowledgmentContextMenu} from "./AcknowledgmentContextMenu/AcknowledgmentContextMenu";
import {AvatarGroupUsersContextMenu} from "./AvatarGroupUsersContextMenu/AvatarGroupUsersContextMenu";
import {TreeQuickActionsContextMenu} from "./TreeQuickActionsContextMenu/TreeQuickActionsContextMenu";
import {ProfileContextMenu} from "./ProfileContextMenu/ProfileContextMenu";


export const MainContextMenuManager = () => {
    return (
        <ContextMenuManager renderContextMenu={renderContextMenu}/>
    );
}


function renderContextMenu(type: ContextMenuType, params: any, handleClose: any, isDark?: boolean) {
    switch (type) {
        case 'item':
            return <ItemContextMenu {...params} handleClose={handleClose}/>;
        case 'avatar':
            return <AvatarUploadContextMenu {...params} handleClose={handleClose} isDark={isDark}/>
        case 'document':
            return <DocumentContextMenu {...params} handleClose={handleClose}/>;
        case 'workspace':
            return <WorkspaceContextMenu {...params} handleClose={handleClose} isDark={isDark}/>;

        case 'notification-centre':
            return <NotificationPanel/>
        case 'add-to-cluster':
            return <AddToClusterContextMenu {...params} handleClose={handleClose} isDark={isDark}/>;
        case 'editor-text':
            return <TextToolbar {...params} handleClose={handleClose} isDark={isDark}/>;
        case 'editor-trigger':
            return <TriggerToolbar {...params} handleClose={handleClose} isDark={isDark}/>;
        case 'editor-table':
            return <TableToolbar {...params} handleClose={handleClose} isDark={isDark}/>;
        case 'editor-image':
            return <ImageToolbar {...params} handleClose={handleClose} isDark={isDark}/>;
        case 'editor-callout':
            return <CalloutToolbar {...params} handleClose={handleClose} isDark={isDark}/>;
        case 'editor-embed':
            return <EmbedToolbar {...params} handleClose={handleClose} isDark={isDark}/>;
        case 'editor-link':
            return <LinkInContextEditBar {...params} handleClose={handleClose} isDark={isDark}/>;
        case 'editor-plus':
            return <PlusToolbar {...params} handleClose={handleClose} isDark={isDark}/>;
        case 'select-options':
            return <SelectOptions {...params} handleClose={handleClose} isDark={isDark}/>;
        case 'calendar-select-options':
            return <CalendarSelectOptions {...params} handleClose={handleClose} isDark={isDark}/>;
        case 'calendar-select-repeat-options':
            return <CalendarSelectRepeatOptions {...params} handleClose={handleClose} isDark={isDark}/>;
        case 'acknowledgments-overview':
            return <AcknowledgmentContextMenu {...params} handleClose={handleClose} isDark={isDark}/>;
        case 'avatar-group-users':
            return <AvatarGroupUsersContextMenu {...params} handleClose={handleClose} isDark={isDark}/>;
        case 'tree-quick-actions':
            return <TreeQuickActionsContextMenu {...params} handleClose={handleClose} isDark={isDark}/>;
        case 'profile':
            return <ProfileContextMenu {...params} handleClose={handleClose}/>;
        default:
            return null;
    }
}
